import React from 'react';
import ReactDOM from 'react-dom';
import configureStore from './redux/store';
import AppContainer from 'react-hot-loader/lib/AppContainer';
import Root from './Root';
import AbacusClientUtils from '@homeaway/abacus-client-utils';

const HP_AA = 'HA_ptaHpFirstAAtest';

// Polyfills
import 'whatwg-fetch';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

function initReactApp() {
  // Initial state as set by the server-side render
  const initialState = window.__INITIAL_STATE__;

  const store = configureStore(initialState);

  const abacusExperiments = store.getState().abacus.experiments;
  AbacusClientUtils.initialize(abacusExperiments);

  if (abacusExperiments[HP_AA]) {
    AbacusClientUtils.evaluateExperimentAndLog(HP_AA);
  }

  ReactDOM.hydrate(
    <AppContainer store={store}>
      <Root store={store}/>
    </AppContainer>,
    document.getElementById('root')
  );

  // Hot module replacement in development env only
  if (module.hot) {
    module.hot.accept('./Root', () => {
      const RootRequired = require('./Root').default;
      ReactDOM.unmountComponentAtNode(document.getElementById('root'));
      ReactDOM.hydrate(
        <AppContainer store={store}>
          <RootRequired store={store} />
        </AppContainer>,
        document.getElementById('root')
      );
      console.log(`[HMR] Rendered at ${new Date().toLocaleTimeString()}`); // eslint-disable-line
    });
  }
}

function startApp() {
  if (document.readyState !== 'loading') {
    initReactApp();
  } else {
    document.addEventListener('DOMContentLoaded', initReactApp);
  }
}

startApp();



// WEBPACK FOOTER //
// ./src/universal/index.js